import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Badge } from "react-bootstrap";
import { getUserState } from "../../../app/selector";
import { ReactComponent as Do } from "../../../resources/do.svg";
import { ReactComponent as DoNot } from "../../../resources/do-not.svg";
import { ReactComponent as Next } from "../../../resources/caret-right-fill.svg";
import { ReactComponent as Prev } from "../../../resources/caret-left-fill.svg";
import PhotoThumbnail from "pages/common/photo/PhotoThumbnail";
import { BACKEND_URL } from "constants";
import MessagePanel from "pages/common/popover/MessagePanel";

import manIcon from "../../../resources/Man Confirmation Icon.PNG";
import womanIcon from "../../../resources/Woman Confirmation Icon.jpg";

const AcceptedRequests = () => {
  const navigate = useNavigate();
  const { user } = useSelector(getUserState);

  const [acceptedRequests, setAcceptedRequests] = useState(undefined);
  const [index, setIndex] = useState(0);

  const acceptedRequest = acceptedRequests && acceptedRequests.length > 0 ? acceptedRequests[index] : null;

  useEffect(() => {
    if (acceptedRequests === undefined && user) {
      const payload = {
        user_id: user.user_id,
      };

      axios
        .post(BACKEND_URL + "/request/check-accepted", payload)
        .then((response) => {
          setAcceptedRequests(response.data);
        })
        .catch((e) => {
          console.error(e);
          setAcceptedRequests([]);
        });
    }
  }, [acceptedRequests, user]);

  useEffect(() => {
    if (acceptedRequest && !acceptedRequest.confirm_read) {
      const payload = {
        request_id: acceptedRequest.request_id,
      };

      axios
        .post(BACKEND_URL + "/request/confirm-read", payload)
        .then(() => {
          acceptedRequest.confirm_read = 1;
        })
        .catch((e) => {
          console.error("Failed to mark confirm as read:", e);
        });
    }
  }, [index, acceptedRequest]);

  const handleDelete = (requestToDelete) => {
    const payload = {
      request_id: requestToDelete.request_id,
    };

    axios
      .post(BACKEND_URL + "/request/delete", payload)
      .then(() => {
        navigate(0);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const renderAcceptedRequest = (currentRequest) => {
    const isOutgoing = currentRequest.sender_user_id === user.user_id;

    const requestUserId = isOutgoing
      ? currentRequest.receiver_user_id
      : currentRequest.sender_user_id;

    const requestPhotoId = isOutgoing
      ? currentRequest.receiver_photo_id
      : currentRequest.sender_photo_id;

    const receiverPhoto = (
      <PhotoThumbnail
        className="shadow-hover receiver-photo"
        src={`data:image/jpeg;base64,${currentRequest.receiver_photo}`}
        photoId={currentRequest.receiver_photo_id}
      />
    );

    return (
      <div className="request mb-5" key={currentRequest.request_id}>
        <div className="receiver mb-2 accepted-message-row">
          <div className="accepted-message-panel-wrapper">
            <MessagePanel
              receiver_user_id={requestUserId}
              receiver_photo_id={requestPhotoId}
              allowShowProfile
              setShow={() => { }}
            />
          </div>
        </div>

        <div className="sender accepted-photos-row">
          {receiverPhoto}
          <Do className="do" width="64" height="64" />
          <PhotoThumbnail
            className="shadow-hover sender-photo"
            src={`data:image/jpeg;base64,${currentRequest.sender_photo}`}
            photoId={currentRequest.sender_photo_id}
          />
        </div>
      </div>
    );
  };

  const renderAcceptedRequests = (requestsArray) => {
    if (!requestsArray) return null;

    const currentReq = requestsArray[index];
    const isOutgoing = currentReq.sender_user_id === user.user_id;

    let dateString = currentReq.modified_date.replace(" ", "T");
    if (!dateString.match(/(Z|[+-]\d{2}:\d{2})$/)) {
      dateString += "Z";
    }
    const localDate = new Date(dateString);

    const timestamp = localDate.toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    });

    return (
      <div className="requests">
        <h4>
          <div className="top-bar accepted-top-bar">
            <div className="top-bar-badges accepted-left-badges">
              <Badge pill bg="secondary">{timestamp}</Badge>
              <Badge pill bg="secondary">{isOutgoing ? "Outgoing" : "Incoming"}</Badge>
            </div>
            <div className="accepted-top-bar-space"></div>
            <Badge pill bg="success" className="accepted-count-badge">
              {index + 1}/{requestsArray.length}
            </Badge>
          </div>
        </h4>

        {renderAcceptedRequest(currentReq)}

        <div className="action">
          <Button variant="outline-primary" className="round-button-l" disabled={index <= 0} onClick={() => setIndex(index - 1)}>
            <Prev width="64" height="64" />
          </Button>
          <Button variant="outline-danger" className="round-button-l" onClick={() => handleDelete(currentReq)}>
            <DoNot width="64" height="64" />
          </Button>
          <Button variant="outline-primary" className="round-button-l" disabled={index >= requestsArray.length - 1} onClick={() => setIndex(index + 1)}>
            <Next width="64" height="64" />
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className="accepted-requests-page content-block flex bg-light p-4 rounded">
      <h1 className="text-center menu-title">Confirms</h1>

      {acceptedRequests?.length > 0 ? (
        renderAcceptedRequests(acceptedRequests)
      ) : (
        <div className="d-flex flex-column align-items-center mt-4">
          <div className="sender accepted-photos-row">
            <img className="shadow-hover receiver-photo" src={manIcon} alt="Receiver confirmation" />
            <Do className="do" width="64" height="64" />
            <img className="shadow-hover sender-photo" src={womanIcon} alt="Sender confirmation" />
          </div>

          <div className="accepted-empty-state-wrapper text-center text-muted mt-4 px-3">
            <h5 className="empty-state-heading mb-2">No confirmations yet</h5>
            <p className="empty-state-body">
              Above is an example of what a confirmation request will look like
              once you start receiving them. Send more requests to get your first confirmation!
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AcceptedRequests;